<template>
    <div>

        <!-- image -->
        <tq-img-fill-blur :pp_img-url_s="p_questEvent_c.qev_cm_getImageFile_c(p_systemLangCode_e).fi_url_s" class="TQ_border_bottom"/>

        <!-- title -->
        <div class="TQ_text_32px" >
            {{p_questEvent_c.cm_qev_getName_fs(p_systemLangCode_e)}}
        </div>

        <!-- date -->
        <div class="TQ_margin_4px TQ_text_16px">
            {{format_dateFull(p_questEvent_c.qev_startingDate_t)}}
        </div>

        <!-- ticket status -->
        <div class="TQ_text_capitalize TQ_text_20px TQ_border_top" v-if="[enum_questTicketStatus.canceled, enum_questTicketStatus.expired, enum_questTicketStatus.waitingToApprove, enum_questTicketStatus.creatorRequest].includes(p_questEventTicket_c.qt_status_e)">

            <!--<div v-if="[enum_questTicketStatus.approved, enum_questTicketStatus.charged].includes(p_questEventTicket_c.qt_status_e)"-->
                 <!--class="TQ_bg_green TQ_padding_8px">-->
                <!--{{ass_string.oneWord_approved[p_systemLangCode_e]}}-->
            <!--</div>-->
            <div v-if="p_questEventTicket_c.qt_status_e === enum_questTicketStatus.canceled" class="TQ_bg_red TQ_padding_8px">
                {{ass_string.twoWords_TicketCancel[p_systemLangCode_e]}}
            </div>
            <div v-else-if="p_questEventTicket_c.qt_status_e === enum_questTicketStatus.expired" class="TQ_bg_red TQ_padding_8px">
                {{ass_string.twoWords_TicketExpired[p_systemLangCode_e]}}
            </div>
            <div v-else-if="[enum_questTicketStatus.waitingToApprove, enum_questTicketStatus.creatorRequest].includes(p_questEventTicket_c.qt_status_e)" class="TQ_bg_gold_w TQ_padding_8px">
                {{ass_string.threeWords_waitingToApprove[p_systemLangCode_e]}}
            </div>
            <div v-else-if="!p_questEvent_c.qev_startingDate_t" class="TQ_bg_red TQ_padding_8px">
                {{ass_string.sentence_joinToStartQuest[p_systemLangCode_e]}}
            </div>
        </div>

        <!--<div class="TQ_border_top">-->
        <!--    <div class="TQ_inline TQ_padding_8px">-->
        <!--        <img :src="ass_img_clock" title="Quest Duration" class="TQ_width_32px "/><br>-->
        <!--        {{format_durationMinutes(p_questEvent_c.qev_durationInMinutes_n,p_systemLangCode_e)}}-->
        <!--    </div>-->
        <!--    <div class="TQ_inline TQ_direction_ltr TQ_padding_8px">-->
        <!--        <img :src="ass_img_playersGroup" title="Spots Left" class="TQ_width_32px"/><br>-->
        <!--        {{helper_getObjSize(p_questEventTicket_c.qt_playersJoinDate_byUserId_t)}} / {{p_questEventTicket_c.qt_spots_n}}-->
        <!--    </div>-->
        <!--    <div class="TQ_inline TQ_padding_8px" v-if="p_ticketOwner_b">-->
        <!--        <img :src="ass_img_profit_b" title="Cost" class="TQ_width_32px "/><br>-->
        <!--        {{format_cost(p_questEventTicket_c.qt_cost_c)}}-->
        <!--    </div>-->
        <!--</div>-->

    </div>
</template>

<script>
    import {FB_QuestEvent} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {
        format_questType
    } from "../../../../../functions/src/shareCode/Share_S_Format";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqOnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import {enum_questTicketStatus} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {obj_size_fn} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {
        ass_img_clock,
        ass_img_playersGroup_b, ass_img_profit_b,
        ass_img_type
    } from "../../../../assets/scripts/Ass_Files";
    import {
        format_cost_s,
        format_date_YYYY_MM_DD_hh_mm_fs,
        format_duration_minutes
    } from "../../../../../functions/src/shareCode/Share_S_Format";
    import {FB_QuestTicket} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";

    export default {
        name: "c_Player_Tickets_Item_Ticket",
        components: {TqImgFillBlur, TqOnTopContainer},
        props:{
            p_questEvent_c: {
                type:FB_QuestEvent,
                require:true
            },
            p_questEventTicket_c:{
                type:FB_QuestTicket,
                require:true
            },
            p_ticketOwner_b:{
                type:Boolean,
                require:true
            },
            p_systemLangCode_e:{
                type:String,
                require: true
            },

        },
        data(){
            return {
                // imports
                ass_string : ass_strings,
                enum_questTicketStatus:     enum_questTicketStatus,
                ass_img_clock : ass_img_clock,
                ass_img_type : ass_img_type,
                ass_img_playersGroup : ass_img_playersGroup_b,
                ass_img_profit_b : ass_img_profit_b,
            }
        },
        methods:{
            helper_getObjSize               : obj_size_fn,
            format_dateFull                 : format_date_YYYY_MM_DD_hh_mm_fs,
            format_durationMinutes          : format_duration_minutes,
            format_questType                : format_questType,
            format_cost                     : format_cost_s,
        },


    }
</script>

<style scoped lang="scss">




    .topImg{
        border-bottom: 1px solid black;
        border-radius: 5px 5px 0px 0px;
    }

    .approve{
        background: green;
        padding: 8px;
        color:white;
        border-radius: 0px 0px 5px 5px;
    }





</style>